import React from 'react'
import {
  AuthProvider,
  type ServerAuthProviderConfig,
} from '@rumah-pendidikan/auth/react'

import { SESSION } from 'src/constant'
import { auth } from 'src/lib/auth'

const baseConfig = auth.reactConfig as ServerAuthProviderConfig

const reactConfig: ServerAuthProviderConfig = {
  ...baseConfig,
  initialization: {
    ...baseConfig.initialization,
    // Only bootstrap for users we already signed in. Guests go straight to
    // /login, which signs them in silently anyway.
    serverGuestLoginIdentifier: { cookieName: SESSION.USER_SESSION },
  },
}

export function IdpAuthProvider({ children }: { children: React.ReactNode }) {
  return <AuthProvider config={reactConfig}>{children}</AuthProvider>
}
